module.exports = ".hx-mask {\n  width: 100vh;\n  height: 100vh;\n  position: fixed;\n  background: rgba(0, 0, 0, 0.5);\n  top: 0;\n  z-index: 99; }\n"